const CURRENT_USER = "currentUser";
const TOKEN_NAME = "token";
const MENU_PROFILE = "menuProfile";

export default {
  CURRENT_USER,
  TOKEN_NAME,
  MENU_PROFILE,
};
